export default function toJSON(obj){
    const json = JSON.stringify(obj);
    return json
}